import React, { ReactNode } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

export interface BlogAskADemoContentProps
  extends Omit<DefaultBsComponent, 'children'> {
  children?: undefined;
  ctas: ReactNode;
  hasImage?: boolean | null;
}
export const BlogAskADemoZoneButton = ({
  ctas,
  className,
  as: Component = 'div',
  hasImage,
  ...props
}: BlogAskADemoContentProps) => {
  return (
    <Component
      {...props}
      className={classNames(
        'BlogAskADemoZoneButton',
        'mt-24 -mb-16',
        !hasImage && 'w-full sm:w-auto sm:pl-48 sm:mt-0',
        className,
      )}
    >
      {ctas && ctas}
    </Component>
  );
};
